// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2mpyP","colMin":"styles_colMin__2wU72","colCheckbox":"styles_colCheckbox__2AGCt"};